import React, { createContext, useContext, useEffect, useState } from 'react';

const CartCtx = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem('nm_cart') || '[]'); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem('nm_cart', JSON.stringify(items));
  }, [items]);

  const add = (p) => {
    setItems((prev) => {
      const ex = prev.find((i) => i.id === p.id);
      if (ex) return prev.map((i) => (i.id === p.id ? { ...i, qty: i.qty + 1 } : i));
      return [...prev, { ...p, qty: 1 }];
    });
    setOpen(true);
  };

  const remove = (id) => setItems((p) => p.filter((i) => i.id !== id));
  const setQty = (id, qty) => {
    if (qty <= 0) return remove(id);
    setItems((p) => p.map((i) => (i.id === id ? { ...i, qty } : i)));
  };
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const total = items.reduce((s, i) => s + i.qty * i.price, 0);

  return (
    <CartCtx.Provider value={{ items, add, remove, setQty, clear, count, total, open, setOpen }}>
      {children}
    </CartCtx.Provider>
  );
};

export const useCart = () => useContext(CartCtx);
